import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { MdInfo } from 'react-icons/md'
import {useState} from "react";

const TooltipInfo = (props) => {
    if (!props.text) return null

    // sterowanie widocznością Tooltip-a
    // (domyślnie bootstrap zamyka tooltip-a przy onMouseLeave na triggerze)
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleHide = () => setShow(false);


    const maxWidth = props.maxWidth || '400px'
    const minWidth = props.minWidth || 'auto'
    const tooltipStyle = {
        '--tooltip-max-width': maxWidth,
        '--tooltip-min-width': minWidth,
    }

    return (
        <OverlayTrigger
            placement={props.placement || 'top'}
            show={show}
            overlay={
                <Tooltip
                    id={`tooltip-${
                        props.text?.substring(0, 10)?.replace(/\s/g, '') ||
                        'default'
                    }`}
                    className='tooltip-info-custom'
                    style={tooltipStyle}
                    onMouseEnter={handleShow}
                    onMouseLeave={handleHide}
                >
                    <div
                        style={{
                            textAlign: 'left',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: props.text || 'nie dodano jeszcze opisu',
                        }}
                    ></div>
                </Tooltip>
            }
        >
            <div
                className={props.className || 'd-inline-block ms-2'}
                onMouseEnter={handleShow}
                onMouseLeave={handleHide}
            >
                <MdInfo
                    style={{ marginBottom: '15px' }}
                    color={props.color || 'orange'}
                    size={props.size || 20}
                />
            </div>
        </OverlayTrigger>
    )
}

TooltipInfo.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.number,
    placement: PropTypes.string,
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default TooltipInfo
